import { PortfolioGameResult } from '../types';

/** Whole seconds for ranking. */
export function durationSeconds(duration: number): number {
  return Math.round(duration);
}

/**
 * Survivor daily rank (wins only): most tiles selected first, then fastest time.
 */
export function compareSurvivorLeaderboardEntries(
  a: PortfolioGameResult,
  b: PortfolioGameResult
): number {
  const tileDiff = b.selectedTileCount - a.selectedTileCount;
  if (tileDiff !== 0) return tileDiff;
  return durationSeconds(a.duration) - durationSeconds(b.duration);
}

export function sortSurvivorLeaderboard(results: PortfolioGameResult[]): PortfolioGameResult[] {
  return [...results].sort(compareSurvivorLeaderboardEntries);
}

export function isSameSurvivorEntry(a: PortfolioGameResult, b: PortfolioGameResult): boolean {
  if (a.id && b.id) return a.id === b.id;
  return (
    a.timestamp === b.timestamp &&
    a.selectedTileCount === b.selectedTileCount &&
    durationSeconds(a.duration) === durationSeconds(b.duration) &&
    a.won === b.won
  );
}

/** 1-based rank for a winning run on today's board. */
export function rankSurvivorEntry(
  results: PortfolioGameResult[],
  entry: PortfolioGameResult
): number | null {
  if (!entry.won) return null;

  const wins = results.filter((result) => result.won);
  const merged = sortSurvivorLeaderboard(
    wins.some((result) => isSameSurvivorEntry(result, entry)) ? wins : [...wins, entry]
  );
  const index = merged.findIndex((result) => isSameSurvivorEntry(result, entry));
  return index < 0 ? merged.length : index + 1;
}
